<template>
  <v-switch
    class="text-xs-center"
    v-model="localBlocked"
    :label="''"
    :color="localBlocked ? 'red' : ''"
    @change="onToggle"
  />
</template>

<script>
export default {
  name: "StatusToggle",
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      required: false,
    },
    resource: {
      type: String,
      default: "passenger",
    },
    activeLabel: {
      type: String,
      default: null,
    },
    inactiveLabel: {
      type: String,
      default: null,
    },
    confirmBlockMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    activeLabelText() {
      return this.activeLabel || this.$t("globalsShared.statusToggle.active");
    },
    inactiveLabelText() {
      return (
        this.inactiveLabel || this.$t("globalsShared.statusToggle.blocked")
      );
    },
    confirmBlockText() {
      return (
        this.confirmBlockMessage ||
        this.$t("globalsShared.statusToggle.confirmBlock")
      );
    },
  },
  data() {
    return {
      // localBlocked = true means account is blocked (blacklisted)
      localBlocked: !!this.value,
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.localBlocked = !!val;
    },
  },
  methods: {
    onToggle(val) {
      // val === true => we are blocking (disabled = 1)
      const disabled = val ? 1 : 0;
      const id = this.item.id;

      // Block dialog
      if (val) {
        this.$dialova({
          title: this.$t("globalsShared.statusToggle.blockTitle"),
          paragraph: this.confirmBlockText,
          loader: true,
        })
          .then(({ close }) => {
            this.loading = true;
            this.axios
              .put(
                `${this.resource}/${id}/change_disabled_at_value`,
                { disabled }
              )
              .then(() => {
                const statusLabel = this.inactiveLabelText;
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("globalsShared.statusToggle.statusChanged", {
                    status: statusLabel,
                  }),
                  "green"
                );
                close();
              })
              .catch(() => {
                this.localBlocked = false;
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("globalsShared.statusToggle.statusChangeFailed"),
                  "red"
                );
                close();
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {
            // User cancelled - revert toggle
            this.localBlocked = false;
          });
        return;
      }

      // Activate dialog
      this.$dialova({
        title: this.$t("globalsShared.statusToggle.activateTitle"),
        paragraph: this.$t("globalsShared.statusToggle.confirmActivate"),
        loader: true,
      })
        .then(({ close }) => {
          this.loading = true;
          this.axios
            .put(
              `${this.resource}/${id}/change_disabled_at_value`,
              { disabled }
            )
            .then(() => {
              const statusLabel = this.activeLabelText;
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("globalsShared.statusToggle.statusChanged", {
                  status: statusLabel,
                }),
                "green"
              );
              close();
            })
            .catch(() => {
              this.localBlocked = true;
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("globalsShared.statusToggle.statusChangeFailed"),
                "red"
              );
              close();
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          // User cancelled - revert toggle
          this.localBlocked = true;
        });
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  justify-content: center;
  width: 50%;
  height: 50%;
}
</style>


